import { useState, useEffect } from 'react';
import { Routes, Route, NavLink } from "react-router-dom";
import AccountOrders from "./AccountOrders";
import AccountManage from "./AccountManage";
import apiService from '../services/ApiService';
import SkeletonLoader from '../components/SkeletonLoader';
import { useAuth } from './AuthContext';

export default function AccountPage() {
    const [userEmail, setUserEmail] = useState('');
    const [wpEmail, setWpEmail] = useState('');
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const { logout } = useAuth();

    useEffect(() => {
        document.title = "Moje konto - Geometry Hustlers";
    }, []);

    useEffect(() => {
        loadUserData();
    }, []);

    const loadUserData = async () => {
        try {
            // Pobierz dane z naszego API
            const result = await apiService.getUserData();

            if (result.wpEmail) {
                const emailPrefix = result.wpEmail.split('@')[0];
                setUserEmail(emailPrefix);
                setWpEmail(result.wpEmail); // ZAPISZ wpEmail do stanu
            }

            setUserData(result.userData);

        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="account-layout">
            <div className="account-header">
            <h2>Witaj użytkowniku</h2>
            </div>
            <nav className="account-tabs">
            <div className="active">HISTORIA ZAMÓWIEŃ</div>
            </nav>

            <div className="account-content">
            <SkeletonLoader type="orders-table" />
            </div>
            </div>
        );
    }

    return (
        <div className="account-layout">
        {/* Header z powitaniem */}
        <div className="account-header">
        <h2>Witaj {userEmail || 'użytkowniku'}</h2>
        </div>

        {/* Zakładki z przyciskiem wylogowania */}
        <nav className="account-tabs">
        <NavLink to="/account" end className={({ isActive }) => isActive ? 'active' : ''}>
        HISTORIA ZAMÓWIEŃ
        </NavLink>
        <NavLink to="/account/manage" className={({ isActive }) => isActive ? 'active' : ''}>
        ZARZĄDZANIE KONTEM
        </NavLink>
        <button
        className="logout-btn"
        onClick={() => {
            logout();
            window.location.href = '/';
        }}
        >
        WYLOGUJ SIĘ
        </button>
        </nav>

        {/* Content */}
        <div className="account-content">
        <Routes>
        <Route path="" element={<AccountOrders />} />
        <Route path="manage" element={<AccountManage userData={userData} wpEmail={wpEmail} onDataUpdate={loadUserData} />} />
        </Routes>
        </div>
        </div>
    );
}
